<script lang="ts">
  import { isIos, isStandalone, promptInstall, pwa } from '../../pwa.svelte'

  // iOS Safari has no beforeinstallprompt and never will; the only route is the
  // share sheet, so tell the user about it instead of showing a dead button.
  let showIosHint = $derived(!pwa.canInstall && isIos() && !isStandalone())
</script>

{#if pwa.canInstall}
  <button class="touch-target install" type="button" onclick={promptInstall}>
    Install app
  </button>
{:else if showIosHint}
  <p class="muted hint">Install: tap Share, then “Add to Home Screen”.</p>
{/if}

<style>
  .install {
    background: var(--color-field);
    color: var(--color-on-field);
    border: 0;
    border-radius: 6px;
    padding: 8px 14px;
    font-weight: 600;
    cursor: pointer;
  }

  .install:hover {
    filter: brightness(1.12);
  }

  .hint {
    font-size: 12px;
  }
</style>
